
export const setFocus= (ref) => {
    console.log(">> setFocus <<<<");
    console.log("ref: ", ref);
    if (ref && ref.current)
        ref.current.focus();
}



